import { render, staticRenderFns } from "./CollectPrintList.vue?vue&type=template&id=2195c76c&scoped=true&"
import script from "./CollectPrintList.vue?vue&type=script&lang=ts&"
export * from "./CollectPrintList.vue?vue&type=script&lang=ts&"
import style0 from "./CollectPrintList.vue?vue&type=style&index=0&id=2195c76c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2195c76c",
  null
  
)

export default component.exports